import { FC, memo } from 'react'
import { createIcon, IconProps } from '@chakra-ui/icons'

import CustomIcon from '../../CustomIcon'

const ToolsWenchIcon = createIcon({
  displayName: 'ToolsWenchIcon',
  viewBox: '0 0 24 24',
  path: (
    <>
      <path
        d="M11.26636,9.602,3.64858,17.21987a2.21434,2.21434,0,0,0,0,3.13157h0a2.21435,2.21435,0,0,0,3.13155,0L14.398,12.73365a4.97516,4.97516,0,0,0,6.355-3.21256A4.81619,4.81619,0,0,0,20.97584,7.526a.9974.9974,0,0,0-1.69955-.56587l-1.80446,1.8045a.5.5,0,0,1-.70715,0L15.23538,7.2353c-.19526-.19526-.19574-.51136.18665-.89373L17.04,4.72366a.99738.99738,0,0,0-.56577-1.69951,4.81738,4.81738,0,0,0-1.99185.22173,4.97538,4.97538,0,0,0-3.216,6.35615Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const ToolsWench: FC<IconProps> = (props) => {
  return <CustomIcon as={ToolsWenchIcon} {...props} />
}

export default memo(ToolsWench)
